import colors from '../../colors';
import sizes from '../../sizes';
import fonts from '../../fonts';
import scrollbar from '../scrollbar';

const lightBase = {
    scrollbar,
    current: {
        text: {
            color: colors.primary700,
            ...fonts.text.sm.semiBold
        }
    },
    inactive: {
        text: {
            color: colors.coolGray500,
            ...fonts.text.sm.semiBold
        },
        hoverText: {
            color: colors.coolGray700,
            ...fonts.text.sm.semiBold
        },
        focusText: {
            color: colors.coolGray500,
            ...fonts.text.sm.semiBold
        }
    },
    disabled: {
        text: {
            color: colors.coolGray400,
            ...fonts.text.sm.semiBold,
            opacity: 0.5
        }
    },
    spacing: {
        default: 12,
        stretch: 32
    },
    gradient: {
        width: sizes.fixedSpacing['7xl'],
        height: sizes.fixedSpacing['4xl'],
        overlayHeight: 44,
        backgroundColor: colors.white,
        left: {
            background: 'linear-gradient(to left, rgba(255, 255, 255, 0.00) -8.11%, #FFF 50%)'
        },
        right: {
            background: 'linear-gradient(to right, rgba(255, 255, 255, 0.00) -8.11%, #FFF 50%)'
        }
    }
};

export default lightBase;
